module.exports = __webpack_public_path__ + "static/media/IMG_3459-3.7ddece8e.jpg";